<!--
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：アプリコンポーネント
 *
 * 作成者：2021/11/19 ノア）黄
 * 最終修正者：2021/11/19 ノア）黄
 *
 -->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script lang="ts">
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import 'reflect-metadata'
import { Component, Vue } from 'vue-property-decorator'
import { refreshToken } from '@/store/apis'
import { onAppMounted, onAppDestroyed } from '@/service/refreshAndCloseWindowService'

/**
 * アプリコンポーネント
 *
 * @class
 */
@Component({
  name: 'app'
})
export default class App extends Vue {
  /**
   * タイマーID
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  intervalId: any = null

  /**
   * インスタンスがマウントされたちょうど後にフック処理
   *
   * @returns {void}
   */
  mounted(): void {
    onAppMounted()

    this.intervalId = setInterval(async () => {
      await refreshToken()
    }, 10000)
  }

  /**
   * コンポーネントが破棄される前に
   *
   * @returns {void}
   */
  beforeDestroy(): void {
    // コンポーネントが破棄される前にタイマーを消去する
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  }

  /**
   * インスタンスが破棄された後にフック処理(VUEからextends)
   *
   * @returns {void}
   */
  destroyed(): void {
    onAppDestroyed()
  }
}
</script>

<style lang="scss">
#app,
body {
  z-index: 0;
  padding: 0;
  margin: 0;
}
</style>
